import axios from "axios";
export default {
  indexSwiper() {
    return axios({
      url: "/api/index-swiper",
      method: "get",
      params: {}
    });
  },
  wapSwiper() {
    return axios({
      url: "/api/wap-swiper",
      method: "get",
      params: {}
    });
  }
};



// WEBPACK FOOTER //
// ./src/api/index.js